var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ProjectService } from './project/project.service';
import { MerchantService } from './merchant/merchant.service';
// import { DashboardLazyModule } from './shared-module/dashboard-shared.module';
import { SharedLazyModule } from './shared-module/shared-lazy.module';
import { TasksSharedModule } from './shared-module/tasks-shared.module';
// angular components
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// root Component
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//
// services
import { UserService } from './user/user.service';
import { AuthGuard } from './route-guard';
import { ToastrService } from './toastr.service';
import { TeamService } from './team/team.service';
import { LoaderService } from './loader.service';
import { DataService } from './settings/data.service';
import { AppUtil } from './app.service';
import { SettingsService } from './settings/settings.service';
import { ManagerService } from './manager/manager.service';
import { StorageService } from './storage.service';
import { DriverService } from './driver/driver.service';
import { CustomerService } from './customer/customer.service';
import { TasksService } from './tasks/tasks.service';
import { ChartData } from './tasks/chart-data';
import { TaskSampleCSV } from './tasks/taskSampleCSV';
import { CalLocale } from './tasks/calLocale';
import { BillingService } from './billing/billing.service';
import { DashboardService } from './dashboard/dashboard/dashboard.service';
import { AwsUtil } from './common/aws.service';
import { CognitoUtil } from './common/cognito.service';
import { HttpService } from './common/http.service';
import { ReportsService } from './report/reports.service';
import { AuthService } from './common/auth.service';
import { StartupService } from './common/startup.service';
import { CustomerSampleCSV } from './customer/customerSampleCSV';
import { DriverSampleCSV } from './driver/driverSampleCSV';
import { DarkMap } from './dashboard/dashboard/darkMap';
import { CountynameService } from './user/signup/countyname.service';
// import {WebhookService} from './settings/webhook/webhook.service';
import { ConfirmationService } from 'primeng/api';
// import {GeofenceSampleCSV} from './settings/geo-fence/geofenceSampleCSV';
// Below component's have some problem while implenting lazyloading
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { LocalStorageModule } from 'angular-2-local-storage';
// where need's use below component
import { SocketIo } from './user/socket.io';
// New component's for multi lingal with Lazy loading.....
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomFieldsService } from './settings/custom-fields/custom-fields.service';
import { PricingEarningsService } from './settings/pricing-earings/pricing-earnings.service';
import { CustomauthService } from './customcommon/customauth.service';
// import { CrmComponent } from './settings/crm/crm.component';
// import {GeoFenceService} from './settings/geo-fence/geo-fence.service';
import { CustomcognitoServiceUtil } from './customcommon/customcognito.service';
import { CustomuserService } from './user/customuser.service';
// import { CustomFormVerificationService } from './custom-form-verification/custom-form-verification.service';
import { CustomerFormService } from './settings/customer-form/customer-form.service';
import { FavouriteLocationService } from './favourite-location/favourite-location.service';
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}
export function startupServiceFactory(startupService) {
    return function () { return startupService.load(); };
}
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        NgModule({
            declarations: [
                AppComponent,
            ],
            imports: [
                BrowserModule,
                BrowserAnimationsModule,
                ToastModule.forRoot(),
                TranslateModule.forRoot({
                    loader: {
                        provide: TranslateLoader,
                        useFactory: HttpLoaderFactory,
                        deps: [HttpClient]
                    }
                }),
                CommonModule,
                AppRoutingModule,
                HttpModule,
                LocalStorageModule.withConfig({
                    prefix: 'my-app',
                    storageType: 'localStorage'
                }),
                HttpClientModule,
                SharedLazyModule,
                TasksSharedModule,
            ],
            providers: [UserService, CustomauthService, SocketIo, DashboardService, DriverSampleCSV,
                SettingsService, ManagerService, StorageService, DriverService, TeamService,
                CustomerService, TasksService, AuthGuard, ToastrService, LoaderService, CustomerFormService,
                DataService, AppUtil, ChartData, TaskSampleCSV, CalLocale, CustomerSampleCSV, AwsUtil,
                CognitoUtil, HttpService, ReportsService, AuthService, ConfirmationService, CustomcognitoServiceUtil,
                BillingService, DarkMap, CountynameService, CustomFieldsService, PricingEarningsService, CustomuserService,
                ProjectService, MerchantService, FavouriteLocationService,
                StartupService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: startupServiceFactory,
                    deps: [StartupService],
                    multi: true
                }],
            bootstrap: [AppComponent],
            exports: [SharedLazyModule,
            ]
        })
    ], AppModule);
    return AppModule;
}());
export { AppModule };



//////////////////
// WEBPACK FOOTER
// ./src/app/app.module.ts
// module id = ./src/app/app.module.ts
// module chunks = main